export const cookieConsent = {
  cookieConsentTitle: "Cookies and privacy",
  cookieConsentMessage: "We use cookies and similar technologies to improve your experience and measure site usage.",
  cookieConsentAcceptBtn: "Accept",
  cookieConsentRejectBtn: "Reject",
};
